import { Box, Button as MatButton, DialogActions, DialogContent, styled } from '@mui/material';

export const Button = styled(MatButton)`
  min-width: 100px;
`;

export const StyledDialogActions = styled(DialogActions)`
  margin: 0;
`;

export const StyledDialogContent = styled(DialogContent)`
  overflow: auto;
  max-height: 500px;
  padding: 20px;
`;

export const StyledEntityName = styled('span')`
  padding: 2px 4px;
  border-radius: 3px;
  margin: 0 3px;
  white-space: nowrap;
`;

export const IconBackground = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;
